import React, {useState} from 'react'
import dollarSymbol from '../../../../../images/dollarSymbol.svg'
import {FeesField} from '../../IAppModels'
import {preventScroll, restrictDecimal} from '../../../../../../utils/helper'

export const FeesTextInput = ({
  fieldLabel,
  fieldName,
  data,
  updateData,
  required = false,
  hasError,
}: FeesField) => {
  const [validation, setValidation] = useState<any>({
    setupFees: '',
    monthlyFees: '',
    perMin: '',
    perTpv: '',
    monthlyMin: '',
    lateChargeFees: '',
    salesTax: '',
    stripeFees: '',
    creditAmount: '',
  })

  const handleValidation = (validationValue: any, inputValue: any) => {
    const value = {...validation}
    if (validationValue < 0) {
      value[inputValue] = 'Value should be positive'
    } else {
      value[inputValue] = ''
    }
    setValidation(value)
    if (required === true) {
      if (Number(validationValue) === 0) {
        value[inputValue] = 'Value should be positive'
        setValidation(value)
      }
      if (validationValue === '') {
        value[inputValue] = 'required field'
        setValidation(value)
      }
    }
  }

  return (
    <div className='col-sm-4 col-md-4 col-lg-4 mt-3'>
      <div>
        <span className={`fs-6 ${required && 'required'}`}>{fieldLabel}</span>
      </div>
      <div>
        <div className='d-flex align-items-center position-relative my-1'>
          <span className='svg-icon svg-icon-1 position-absolute ms-6'>
            <img src={dollarSymbol} alt='currency' />
          </span>
          <input
            type='number'
            min={0}
            className='form-control form-control-solid ps-14'
            name='setup fees'
            placeholder='0.00'
            value={data.pricingSetup[fieldName]}
            onFocus={(e) => preventScroll(e)}
            onChange={(e) => (
              updateData({
                pricingSetup: {
                  ...data.pricingSetup,
                  [fieldName]: restrictDecimal(e.target.value),
                },
              }),
              handleValidation(e.target.value, fieldName)
            )}
          />
        </div>
        {validation[fieldName] && hasError && (
          <div className='w-150px text-danger'>{validation[fieldName]}</div>
        )}
      </div>
    </div>
  )
}
